import { useMutation } from "@tanstack/react-query";
import { updatePreferencesCommunication } from "../services/users.service";

export const useUpdatePreferencesCommunication = () => {
  return useMutation({
    mutationFn: updatePreferencesCommunication,
  });
};
